export default __webpack_public_path__ + "static/media/p2p-m.f83dbe86.svg";